import { extractDateFromString, extractDate } from '@/utils/datetime'
import { ref } from 'vue'
import { useCalendarStore } from '@/views/apps/calendar/useCalendarStore'


export const useReserveListStore = defineStore('reserveListStore', () => {
  // State
  const fetchedReserveCustomers = ref([])
  const pendingCustomerCount = ref(0) // It's being updated in useCalendar fetchEvents method
  const isLoading = ref(false)
  const isSaving = ref(false)
  const selectedEmployee = ref(null)
  const selectedServiceEkey = ref(null)

  const calendarStore = useCalendarStore()

  const defaultItem = {
    id: null,
    ekey: '',
    clientId: '',
    clientEkey: '',
    clientName: '',
    clientSurname: '',
    clientPhone: '',
    notes: '',
    employeeId: '',
    salonerClientId: '',
    employeeEkey: 'any_employee',
    serviceEkey: null,
    createTime: new Date().toISOString(),
    expirationTime: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
  }


  // Actions
  const fetchReserveList = async () => { // Run once in calendar.vue onMounted

    isLoading.value = true // Set loading state

    try {
      let end = new Date(calendarStore.calendarApi.view.activeEnd)
      end.setDate(end.getDate() - 1)
      let currentCalendarDate = extractDate(calendarStore.calendarApi.view?.activeStart, '-')
      let currentCalendarEndDate = extractDate(end, '-')

      const response = await $backend(`/reserveList/index?date=${currentCalendarDate}&endDate=${currentCalendarEndDate}`, {
        method: 'GET',
      })

      if(response.success) {
        fetchedReserveCustomers.value = response.data.map(res => {
          const daysLeft = calculateDaysLeft(res)

          return {
            ...res,
            assignedCalendar: calendarStore.employeesCalendars.find(employee => employee.id === res.employeeEkey) || null,
            expires_in: daysLeft, // Add the computed expires_in value
          }
        })

        // if(selectedEmployee.value === null || selectedEmployee.value === 'any_employee') {
        //   pendingCustomerCount.value = fetchedReserveCustomers.value.filter(item =>
        //     new Date(extractDateFromString(item.createTime)+" 00:00:00") <= new Date(currentCalendarDate+" 23:59:00"),
        //   ).length
        // }
        // pendingCustomerCountTotal.value = fetchedReserveCustomers.value.length
      }
      isLoading.value = false

      return response.data
    } catch (error) {
      console.error('Error fetching customers from reserve list:', error)
    }
    isLoading.value = false
    fetchedReserveCustomers.value = [] // Return an empty array in case of an error

    return []
  }

  /**
   * Calculates the number of days left until expiration for a given item.
   * @param {Object} item - The item containing the expirationTime.
   * @returns {number|null} The number of days left, or null if expirationTime is not set.
   */
  const calculateDaysLeft = (item) => {
    return item.expirationTime
      ? Math.max(0, Math.ceil((new Date(item.expirationTime) - new Date()) / (1000 * 60 * 60 * 24)))
      : null
  }


  const addReserveListItem = async (reserveListItem) => {
    return await $backend('/reserveList/save', {
      method: 'POST',
      body: reserveListItem,
    })
  }

  const removeReserveListItem = async (reserveListItemID) => {
    return await $backend('/reserveList/delete', {
      method: 'POST',
      body: {
        ekey: reserveListItemID,
      },
    })
  }

  const updateEmployeesCounters = () => {
    console.log('updateEmployeesCounters')
    const employeesCount = {}

    // Iterate over the array and count occurrences of each employeeEkey
    fetchedReserveCustomers.value.forEach(item => {
      const employeeEkey = item.employeeEkey

      if (!employeesCount[employeeEkey]) {
        employeesCount[employeeEkey] = 0
      }

      employeesCount[employeeEkey]++
    })

    // Update the DOM for each employeeEkey
    Object.entries(employeesCount).forEach(([employeeEkey, counter]) => {
      Array.from(document.getElementsByClassName(`fc-reserve-list-counter-${employeeEkey}`)).forEach(element => {
        element.innerText = counter
        //element.classList.remove('pulse')
      })
    })

  }

  return {
    defaultItem,
    pendingCustomerCount,
    fetchedReserveCustomers,
    isLoading,
    isSaving,
    selectedEmployee,
    selectedServiceEkey,
    fetchReserveList,
    addReserveListItem,
    removeReserveListItem,
    updateEmployeesCounters,
    calculateDaysLeft,
  }

})
